export const ROUTE_PATHS = {
  HOME: '/'
} as const;

export interface Service {
  id: string;
  title: string;
  description: string;
  icon: string;
}

export const CONTACT_INFO = {
  name: 'Leandro Silva',
  title: 'Técnico Especialista em Contabilidade e Fiscalidade',
  email: 'leandro.contabilista.pnf@gmail.com',
  phone: '911 199 028',
  address: 'Castro Daire (Atendimento em todo o país)',
  schedule: 'Segunda a Sábado: 09:00 - 20:00',
  facebook: 'Leandro - Técnico de Contabilidade'
} as const;